import styled from 'styled-components';

export const GooglePayContainer = styled.div`
    background-color: white;
    border-radius: 5px;
    border: 1px solid rgb(198, 198, 198);
    box-shadow: rgba(198, 198, 198, 0.282) 0px 0px 0px;
    display: flex;
    flex-wrap: nowrap;
    -moz-box-pack: justify;
    justify-content: space-between;
    -moz-box-align: center;
    align-items: center;
    padding: 20px;
    cursor: pointer;
    flex-direction: row;
    transition: all 200ms ease 0s;

    @media (max-width: ${props => props.theme.medium}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/GooglePayStyle.js